export const AUTOMATIC_VOICE_STOP_REASONS = new Set([
  "silence_detected",
  "no_speech_timeout",
  "max_recording_timeout",
  "speech_recognition_final",
  "recognition_end",
  "recognition_error",
]);

export const shouldPreserveHandsFree = ({
  reason,
  handsFreeEnabled = false,
  manualOneShot = false,
} = {}) => {
  if (!handsFreeEnabled || manualOneShot) return false;
  return AUTOMATIC_VOICE_STOP_REASONS.has(String(reason || ""));
};

export const shouldDisableHandsFreeForStop = ({
  reason,
  handsFreeEnabled = false,
  manualOneShot = false,
} = {}) => !shouldPreserveHandsFree({ reason, handsFreeEnabled, manualOneShot });


export const shouldPreserveHandsFreeAfterRecognitionError = (errorCode = "") => (
  String(errorCode || "") === "NO_AUDIO"
);
